// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__yunXS","navbar":"Footer_navbar__WcKm0"};